import { VideoSourceModel } from '@_types/organisms';

const getVideoSrc = (id?: string, source?: VideoSourceModel) => {
  if (!id || !source) return undefined;

  if (source === 'youtube') {
    return `https://www.youtube.com/embed/${id}?t=20s&enablejsapi=1`;
  } else {
    return `https://player.vimeo.com/video/${id}`;
  }
};

export default getVideoSrc;
